import React, { useState, useEffect } from 'react';
import '../css/Memberships.css';
import line from '../images/underline.png';

import memberships from '../utils/memberships';

import Membership from './cards/Membership';
import { getRemainingTimeUntilMsTimestamp } from '../utils/countdown';

import Image from 'react-image-webp';
import image from '../images/award-background.png';
import imageWebp from '../images/award-background.webp';

import decoration from '../images/decorations/counseling_decoration_2.png';

const Memberships = () => {
	const [location, setLocation] = useState(null);

	useEffect(() => {
		const fetchLocation = async () => {
			try {
				const response = await fetch(`https://ipinfo.io/json?token=02e14e8acfee94`);
				const data = await response.json();
				// console.log(data);
				setLocation(data.country);
			} catch (error) {
				console.error('Error fetching the location:', error);
			}
		};
		fetchLocation();
	}, []);

	const membershipsList = memberships.map((training) => (
		<Membership key={training.id} membership={training} country={location} />
	));

	const countdownTimestampMs = 'Tue, 16 Sep 2024 16:00:00 GMT-5';

	const defaultRemainingTime = {
		seconds: '00',
		minutes: '00',
		hours: '00',
		days: '00',
	};

	const [remainingTime, setRemainingTime] = useState(defaultRemainingTime);

	function updateRemainingTime(countdown) {
		setRemainingTime(getRemainingTimeUntilMsTimestamp(countdown));
	}

	useEffect(() => {
		const intervalId = setInterval(() => {
			updateRemainingTime(countdownTimestampMs);
		}, 1000);
		return () => clearInterval(intervalId);
	}, [countdownTimestampMs]);

	return (
		<section className='Memberships' id='entrenamientos'>
			<div className='memberships-container container padding'>
				<Image
					webp={imageWebp}
					src={image}
					alt='Memberships Background'
					className='memberships-image'
				/>
				<img src={decoration} alt='Membership Decoration' className='membership-decoration' />
				<div className='memberships-header'>
					<h1>
						BLENDER
						<br />
						<span>JUNIOR PRO</span>
						<img className='convert-underline' src={line} alt='underline' />
					</h1>
				</div>
				{/* <div className='cnt-countdown'>
					<div className='membership-countdown'>
						<h5 className='membership-countdown-title'>Inicio de clases 16 de septiembre</h5>
						<div className='membership-countdown-counter'>
							<div className='membership-countdown-counter-item'>
								<span>Día(s)</span>
								<p>{remainingTime.days}</p>
							</div>
							<div className='membership-countdown-counter-item'>
								<span>Hora(s)</span>
								<p>{remainingTime.hours}</p>
							</div>
							<div className='membership-countdown-counter-item'>
								<span>Minuto(s)</span>
								<p>{remainingTime.minutes}</p>
							</div>
							<div className='membership-countdown-counter-item'>
								<span>Segundo(s)</span>
								<p>{remainingTime.seconds}</p>
							</div>
						</div>
					</div>
				</div> */}
				<div className='memberships-content'>{membershipsList}</div>
			</div>
		</section>
	);
};

export default Memberships;
